import angular from 'angular';
import uiRouter from 'angular-ui-router';
import botManagerComponent from './bot-manager.component';

let botManagerModule = angular.module('app.containers.bot-manager', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('botManager', {
      url: '/bot-manager',
      template: '<bot-manager></bot-manager>'
    });
})

.component('botManager', botManagerComponent);

export default botManagerModule;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/bot-manager/bot-manager.js
 **/